import { NgModule } from '@angular/core';

import { mapToCanActivate, mapToCanDeactivate, RouterModule, Routes } from '@angular/router';
import { CustomerFeature } from '@app/core/models/customer.models';
import { CustomerFeatureGuardService } from '@app/core/services/guards/customer-feature-guard.service';
import { UnsavedFormGuard } from '@app/core/services/unsaved-form-guard.service';
import { ClientComponent } from './client.component';

export const ApolloRoutes: Routes = [
  {
    path: 'monitor',
    loadChildren: () => import('./monitor/monitor.module').then((m) => m.MonitorModule),
    data: {
      title: 'Monitor',
      preload: true,
      isFluid: true,
      accessLevel: 'USER',
      noEmptyAgencyAccess: true,
    },
  },
  {
    path: 'keyfigures',
    loadChildren: () => import('./key-figures/key-figures.module').then((m) => m.KeyFiguresModule),
    data: {
      title: 'Key Figures',
      preload: true,
      isFluid: true,
      accessLevel: 'USER',
      noEmptyAgencyAccess: true,
    },
  },
  {
    path: 'campaign',
    loadChildren: () => import('./campaign-creation/campaign-creation.module').then((m) => m.CampaignCreationModule),
    data: {
      title: 'Campaign Creation',
      preload: true,
      isFluid: true,
      accessLevel: 'USER',
      noEmptyAgencyAccess: true,
    },
  },

  {
    path: 'products',
    loadChildren: () => import('./products/products.module').then((m) => m.ProductsModule),
    data: {
      title: 'Products',
      preload: true,
      isFluid: true,
      accessLevel: 'USER',
      noEmptyAgencyAccess: true,
    },
  },
  {
    path: 'alerts',
    loadComponent: () =>
      import('./alerts/components/page/alerts-center-page.component').then((c) => c.AlertsCenterPageComponent),
    data: {
      title: 'Alerts',
      preload: false,
      isFluid: true,
      feature: CustomerFeature.TriggerNotifications,
      noEmptyAgencyAccess: true,
    },
    canActivate: mapToCanActivate([CustomerFeatureGuardService]),
  },
  {
    path: 'notifications',
    redirectTo: 'alerts',
    pathMatch: 'prefix',
  },
  {
    path: 'pg-goals',
    loadComponent: () => import('./pg-goals-v2/pg-goals.component').then((m) => m.PGGoalsComponent),
    data: {
      title: 'PGs and Goals',
      preload: false,
      isFluid: true,
      noEmptyAgencyAccess: true,
    },
    canDeactivate: mapToCanDeactivate([UnsavedFormGuard]),
  },
  {
    path: 'optimization-settings',
    loadChildren: () =>
      import('./optimization-settings/optimization-settings.module').then((m) => m.OptimizationSettingsModule),
    data: {
      title: 'Optimization Settings',
      preload: true,
      isFluid: true,
      noEmptyAgencyAccess: true,
    },
  },
  {
    path: 'criterion-hub',
    loadChildren: () => import('./criterion-addition/criterion-addition.module').then((m) => m.CriterionAdditionModule),
    data: {
      title: 'Criterion Hub',
      preload: true,
      isFluid: true,
      noEmptyAgencyAccess: true,
    },
  },
  {
    path: 'budget-suggestions',
    loadChildren: () => import('./budget-suggestion/budget-suggestion.module').then((m) => m.BudgetSuggestionModule),
    data: {
      title: 'Budget Suggestions',
      preload: true,
      isFluid: true,
      noEmptyAgencyAccess: true,
    },
  },
  {
    path: 'log',
    loadChildren: () => import('./logs/logs.module').then((m) => m.LogsModule),
    data: {
      title: 'Logs',
      preload: true,
      isFluid: true,
      noEmptyAgencyAccess: true,
    },
  },
  {
    path: 'no-access',
    loadChildren: () => import('./no-access/no-access.module').then((m) => m.NoAccessModule),
    data: {
      title: 'No Access',
      preload: false,
      isFluid: true,
      accessLevel: 'USER',
    },
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
    data: {
      title: 'Settings',
      preload: false,
      isFluid: true,
      isAdminPage: true,
    },
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    data: {
      title: 'Admin',
      preload: false,
      isFluid: true,
      accessLevel: 'CUSTOMER-ADMIN',
    },
  },
  {
    path: 'dev',
    loadChildren: () => import('./dev/dev.module').then((m) => m.DevModule),
    data: {
      title: 'Developer Tools',
      preload: false,
      isFluid: true,
      accessLevel: 'SYS-ADMIN',
    },
  },
  {
    path: 'payment-methods',
    loadChildren: () => import('./payment-methods/payment-methods.module').then((m) => m.PaymentMethodsModule),
    data: {
      title: 'Payment Methods',
      preload: false,
      isFluid: false,
    },
  },
  {
    path: '',
    redirectTo: 'monitor',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ClientComponent,
        data: { title: 'Adspert Login', preload: true },
        children: ApolloRoutes,
      },
    ]),
  ],
})
export class ClientModule {}
